// Mock data para eLauria - Site Institucional

export const companyInfo = {
  name: "eLauria",
  tagline: "Auditoria Independente • Consultoria • Contabilidade",
  foundedYear: 1990,
  location: {
    address: "Rua Rio Madeira, 820, Conj. Vieiralves",
    neighborhood: "Bairro Nossa Senhora das Graças",
    city: "Manaus",
    state: "AM",
    country: "Brasil",
    cep: "69053-030"
  },
  contact: {
    phone: "+55 92 98818-1526",
    whatsapp: "5592988181526",
    email: "enrique.lauria@elauria.com.br",
    website: "www.elauria.com.br"
  },
  logo: "/logo-elauria.png"
};

export const heroContent = {
  headline: "Pioneira no Amazonas em Auditoria, Consultoria e Contabilidade",
  subheadline: "Desde 1990, construindo relações de confiança com metodologia, integridade e excelência técnica.",
  ctaPrimary: {
    text: "Solicitar Proposta",
    link: "/contato"
  },
  ctaSecondary: {
    text: "Enviar Currículo",
    link: "/trabalhe-conosco"
  }
};

export const credibilityItems = [
  {
    id: 1,
    icon: "Calendar",
    title: "Desde 1990",
    description: "Mais de três décadas de experiência consolidada no mercado"
  },
  {
    id: 2,
    icon: "MapPin",
    title: "Atuação no Amazonas",
    description: "Presença regional forte, com conhecimento profundo do mercado local"
  },
  {
    id: 3,
    icon: "Shield",
    title: "Metodologia & Compliance",
    description: "Normas brasileiras e internacionais com rigor técnico"
  },
  {
    id: 4,
    icon: "Users",
    title: "Equipe Qualificada",
    description: "Profissionais especializados e em constante atualização"
  }
];

export const services = [
  {
    id: 1,
    slug: "auditoria-independente",
    icon: "FileCheck",
    title: "Auditoria Independente",
    shortDescription: "Demonstrações financeiras, revisões com fins específicos e procedimentos pré-acordados.",
    fullDescription: "Oferecemos serviços de auditoria independente em conformidade com as normas brasileiras e internacionais, garantindo a confiabilidade das informações financeiras da sua empresa.",
    features: [
      "Auditoria de demonstrações financeiras",
      "Revisão de demonstrações com fins específicos",
      "Procedimentos pré-acordados",
      "Relatórios de auditoria customizados",
      "Due diligence financeira"
    ],
    forWho: "Empresas de médio e grande porte, holdings, grupos empresariais e organizações que precisam de opinião independente sobre suas demonstrações financeiras.",
    results: "Relatórios confiáveis que atendem stakeholders, investidores, bancos e órgãos reguladores."
  },
  {
    id: 2,
    slug: "consultoria-tributaria",
    icon: "Calculator",
    title: "Consultoria Tributária",
    shortDescription: "Planejamento, revisões fiscais, SPED, ECF, e-LALUR/e-LACS e recuperação de créditos.",
    fullDescription: "Otimize sua carga tributária com segurança jurídica. Nossa equipe identifica oportunidades de economia e garante conformidade com a legislação.",
    features: [
      "Planejamento tributário estratégico",
      "Revisão e recuperação de créditos tributários",
      "SPED Fiscal e Contábil",
      "ECF, e-LALUR e e-LACS",
      "Defesa em autos de infração",
      "Análise de passivos tributários"
    ],
    forWho: "Empresas que buscam otimizar tributos, recuperar créditos ou precisam de defesa em processos administrativos.",
    results: "Redução da carga tributária dentro da legalidade e segurança nas obrigações acessórias."
  },
  {
    id: 3,
    slug: "governanca-risco-compliance",
    icon: "ShieldCheck",
    title: "Governança, Risco e Compliance",
    shortDescription: "Auditoria interna, controles internos e governança corporativa.",
    fullDescription: "Estruture sua empresa para o crescimento sustentável com processos robustos de governança, gestão de riscos e conformidade.",
    features: [
      "Auditoria interna e operacional",
      "Implementação de controles internos",
      "Diagnóstico de governança corporativa",
      "Mapeamento e gestão de riscos",
      "Programas de compliance"
    ],
    forWho: "Organizações que buscam profissionalizar sua gestão, atender exigências de investidores ou preparar-se para crescimento.",
    results: "Processos mais eficientes, riscos controlados e maior atratividade para investidores."
  },
  {
    id: 4,
    slug: "terceirizacao-bpo",
    icon: "Building2",
    title: "Terceirização / BPO",
    shortDescription: "Contabilidade, fiscal, folha, gestão financeira e controladoria para grandes empresas.",
    fullDescription: "Concentre-se no seu negócio enquanto cuidamos das rotinas contábeis, fiscais e financeiras com a qualidade e expertise que sua empresa merece.",
    features: [
      "Contabilidade para grandes empresas",
      "Escrituração fiscal completa",
      "Processamento de folha de pagamento",
      "Gestão financeira terceirizada",
      "Controladoria e relatórios gerenciais"
    ],
    forWho: "Empresas de médio e grande porte que desejam qualidade contábil sem estrutura interna robusta.",
    results: "Redução de custos operacionais, informações precisas e conformidade garantida."
  },
  {
    id: 5,
    slug: "trabalhista-previdenciario",
    icon: "UserCheck",
    title: "Serviços Trabalhistas e eSocial",
    shortDescription: "Implementação e rotinas de eSocial, folha de pagamento e benefícios.",
    fullDescription: "Garanta conformidade trabalhista e previdenciária com nossa expertise em eSocial e gestão de pessoal.",
    features: [
      "Implementação e manutenção do eSocial",
      "Processamento de folha de pagamento",
      "Gestão de benefícios",
      "Revisão de obrigações trabalhistas",
      "Rotinas de admissão e rescisão"
    ],
    forWho: "Empresas que precisam de suporte especializado em obrigações trabalhistas e previdenciárias.",
    results: "Conformidade total com eSocial e redução de riscos trabalhistas."
  }
];

export const differentials = [
  {
    id: 1,
    icon: "Clock",
    title: "Atendimento Rápido",
    description: "Respostas ágeis e disponibilidade para atender suas demandas com a urgência que o negócio exige."
  },
  {
    id: 2,
    icon: "Target",
    title: "Soluções Sob Medida",
    description: "Cada cliente é único. Desenvolvemos abordagens personalizadas para cada desafio."
  },
  {
    id: 3,
    icon: "Heart",
    title: "Integridade e Ética",
    description: "Compromisso absoluto com a ética profissional e a transparência em todas as relações."
  },
  {
    id: 4,
    icon: "Award",
    title: "Foco em Qualidade",
    description: "Revisão de qualidade rigorosa em todos os trabalhos para garantir excelência técnica."
  }
];

export const sectors = [
  { id: 1, name: "Indústria", icon: "Factory" },
  { id: 2, name: "Comércio", icon: "ShoppingCart" },
  { id: 3, name: "Serviços", icon: "Briefcase" },
  { id: 4, name: "Construção Civil", icon: "HardHat" },
  { id: 5, name: "Terceiro Setor", icon: "HeartHandshake" },
  { id: 6, name: "Grupos Empresariais", icon: "Network" }
];

export const aboutContent = {
  title: "Nossa História",
  subtitle: "Desde 1990 construindo confiança",
  paragraphs: [
    "A eLauria nasceu em 1990 em Manaus, no coração do Amazonas, com a missão de oferecer serviços de auditoria, consultoria e contabilidade com excelência técnica e integridade absoluta.",
    "Ao longo de mais de três décadas, nos consolidamos como referência regional, atendendo empresas de diversos portes e setores com soluções personalizadas e metodologia alinhada às normas brasileiras e internacionais.",
    "Nossa trajetória é marcada pelo compromisso com a qualidade, pela transparência nas relações e pela constante atualização técnica de nossa equipe. Acreditamos que confiança se constrói com trabalho sério, resultados consistentes e relacionamentos de longo prazo."
  ],
  values: [
    { title: "Integridade", description: "Agimos com ética e honestidade em todas as situações" },
    { title: "Qualidade", description: "Buscamos a excelência em cada entrega" },
    { title: "Transparência", description: "Comunicação clara e aberta com nossos clientes" },
    { title: "Compromisso", description: "Dedicação total às necessidades de cada cliente" }
  ]
};

export const faqs = [
  {
    id: 1,
    question: "Qual o prazo para realização de uma auditoria?",
    answer: "O prazo varia conforme a complexidade e porte da empresa. Após análise inicial, apresentamos cronograma detalhado com as etapas e prazos estimados. Em geral, auditorias podem levar de 2 a 8 semanas."
  },
  {
    id: 2,
    question: "Como funciona o processo de auditoria independente?",
    answer: "O processo inclui planejamento inicial, levantamento de informações, execução dos procedimentos de auditoria, revisão de qualidade e emissão do relatório. Mantemos comunicação constante durante todo o trabalho."
  },
  {
    id: 3,
    question: "As informações da minha empresa são confidenciais?",
    answer: "Absolutamente. Mantemos sigilo total sobre todas as informações de nossos clientes, conforme normas profissionais e legislação vigente. Firmamos acordos de confidencialidade quando solicitado."
  },
  {
    id: 4,
    question: "Quais documentos preciso fornecer?",
    answer: "Depende do serviço contratado. Na proposta comercial, detalhamos toda a documentação necessária. Nossa equipe orienta e auxilia na organização dos documentos."
  },
  {
    id: 5,
    question: "Vocês atendem empresas de outros estados?",
    answer: "Sim, embora nossa sede seja em Manaus, atendemos clientes em todo o Brasil, com equipe preparada para trabalhos presenciais e remotos."
  },
  {
    id: 6,
    question: "Como a eLauria trata os dados pessoais (LGPD)?",
    answer: "Seguimos rigorosamente a Lei Geral de Proteção de Dados. Seus dados são tratados com segurança e utilizados apenas para as finalidades informadas, com seu consentimento expresso."
  }
];

export const careerContent = {
  title: "Cresça com a eLauria",
  subtitle: "Faça parte de uma equipe que valoriza excelência e desenvolvimento profissional",
  description: "Na eLauria, acreditamos que nosso maior patrimônio são as pessoas. Oferecemos um ambiente de trabalho desafiador, oportunidades de crescimento e constante atualização técnica. Se você busca uma carreira sólida em auditoria, consultoria ou contabilidade, venha fazer parte do nosso time.",
  benefits: [
    "Ambiente de aprendizado contínuo",
    "Exposição a projetos desafiadores",
    "Desenvolvimento técnico e profissional",
    "Cultura de integridade e ética"
  ]
};

export const formOptions = {
  serviceAreas: [
    { value: "auditoria", label: "Auditoria Independente" },
    { value: "contabilidade", label: "Contabilidade para Grandes Empresas (BPO)" },
    { value: "tributario", label: "Consultoria Tributária" },
    { value: "governanca", label: "Governança, Risco e Compliance" },
    { value: "esocial", label: "Folha de Pagamento & eSocial" },
    { value: "outro", label: "Outro" }
  ],
  careerAreas: [
    { value: "auditoria", label: "Auditoria" },
    { value: "contabilidade", label: "Contabilidade" },
    { value: "tributario", label: "Tributário" },
    { value: "compliance", label: "Compliance & Risco" },
    { value: "dp", label: "DP & eSocial" },
    { value: "administrativo", label: "Administrativo" }
  ],
  excelLevels: [
    { value: "basico", label: "Básico" },
    { value: "intermediario", label: "Intermediário" },
    { value: "avancado", label: "Avançado" }
  ],
  englishLevels: [
    { value: "nenhum", label: "Nenhum" },
    { value: "basico", label: "Básico" },
    { value: "intermediario", label: "Intermediário" },
    { value: "avancado", label: "Avançado" },
    { value: "fluente", label: "Fluente" }
  ],
  collegePeriods: [
    { value: "1", label: "1º período" },
    { value: "2", label: "2º período" },
    { value: "3", label: "3º período" },
    { value: "4", label: "4º período" },
    { value: "5", label: "5º período" },
    { value: "6", label: "6º período" },
    { value: "7", label: "7º período" },
    { value: "8", label: "8º período" },
    { value: "9", label: "9º período" },
    { value: "10", label: "10º período" }
  ],
  graduationYears: [
    { value: "2025", label: "2025" },
    { value: "2026", label: "2026" },
    { value: "2027", label: "2027" },
    { value: "2028", label: "2028" },
    { value: "2029", label: "2029" },
    { value: "2030", label: "2030" }
  ]
};

export const metaData = {
  home: {
    title: "eLauria | Auditoria, Consultoria e Contabilidade em Manaus",
    description: "Desde 1990, a eLauria é referência em auditoria independente, consultoria tributária e contabilidade no Amazonas. Soluções sob medida com integridade e excelência técnica."
  },
  services: {
    title: "Serviços | eLauria - Auditoria, Consultoria e Contabilidade",
    description: "Conheça nossos serviços: Auditoria Independente, Consultoria Tributária, Governança e Compliance, BPO Contábil e Serviços Trabalhistas. Soluções completas para sua empresa."
  },
  about: {
    title: "Sobre a eLauria | Nossa História desde 1990",
    description: "Conheça a história da eLauria, empresa pioneira em auditoria e consultoria no Amazonas. Mais de 30 anos de experiência, integridade e compromisso com a qualidade."
  },
  careers: {
    title: "Trabalhe Conosco | Carreiras na eLauria",
    description: "Faça parte da equipe eLauria. Oportunidades em auditoria, contabilidade, consultoria tributária e compliance. Envie seu currículo e cresça conosco."
  },
  contact: {
    title: "Contato | Solicite uma Proposta - eLauria",
    description: "Entre em contato com a eLauria. Solicite uma proposta personalizada para auditoria, consultoria ou contabilidade. Atendimento em Manaus e todo o Brasil."
  }
};
